module.exports = __webpack_public_path__ + "img/listview-clonejob.18e129d5.svg";